@if (product()) {
    <section class="p-24:v md:p-32:v lg:p-48:v">
        <div class="content-container">
            <h1 class="c:blue-700">{{ product().title }}</h1>
            <ul class="check m-24:b">
                @for (point of product().presentation.bulletPoints; track $index) {
                    <li [innerHTML]="point"></li>
                }
            </ul>
        </div>
    </section>

    <form
        [formGroup]="form"
        (submit)="submit()"
    >
        <section class="bg:grey-5 p-24:v md:p-32:v lg:p-64:v">
            <div class="content-container">
                <div class="grid-container">
                    <!-- #region device value input and variant switches -->
                    <div class="g-12 sm:g-6">
                        <label
                            for="price"
                            class="fs:l c:blue-700"
                            >Unsubventionierter Kaufpreis des Smartphones:</label
                        >
                        <div
                            class="form-control with-info-tooltip"
                            #priceContainer
                        >
                            <input
                                type="text"
                                id="price"
                                formControlName="value"
                                appPriceInput
                                appSuspendEnter
                                outputType="string"
                                placeholder="Unsubventionierter Kaufpreis"
                                [ctrlErrorMessage]="valueErrorMessage"
                                required
                            />
                            <span class="fit-label dark fw:semibold">€</span>
                            <app-info-tooltip
                                heading="Unsubventionierter Kaufpreis"
                                text="Der unsubventionierte Kaufpreis ist der zum Kaufzeitpunkt gültige
                                    Marktpreis. Wenn das Gerät z.B. im Rahmen eines Mobil&shy;funkvertrags
                                    oder gebraucht erworben wurde, gib bitte den tatsächlichen Neuwert des
                                    Gerätes zum Zeitpunkt des Kaufs an."
                            />
                        </div>

                        <app-variants-fieldset
                            [hasDeductible]="hasDeductible()"
                            [hasMonthlySettlementPeriod]="hasMonthlySettlementPeriod()"
                            [hasTheftCoverage]="hasTheftCoverage()"
                            [boughtInLastTwoWeeks]="boughtInLastTwoWeeks()"
                            (toggleDeductible)="toggleDeductible($event)"
                            (toggleSettlementPeriod)="toggleSettlementPeriod($event)"
                            (toggleTheftCoverage)="toggleTheftCoverage($event)"
                            (toggleBoughtInLastTwoWeeks)="toggleBoughtInLastTwoWeeks($event)"
                        />
                    </div>
                    <!-- #endregion -->

                    <!-- #region price -->
                    <div class="g-12 sm:g-6 bg:grey-5">
                        <app-price-display-card
                            class="lg:g-4"
                            [bannerText]="product().title"
                            [price]="price() === 0 ? undefined : price()"
                            [settlementPeriod]="hasMonthlySettlementPeriod() ? 'month' : 'year'"
                            [taxInfo]="product().orderConfig.taxInfo"
                            buttonText="Diesen Tarif wählen"
                            [buttonDisabled]="form.invalid"
                        >
                            <div class="variant-grade">
                                @if (hasDeductible()) {
                                    @if (hasTheftCoverage()) {
                                        <img
                                            src="assets/img/check24_13.svg"
                                            alt="Check24: Tarifnote: 1,3 Sehr gut."
                                            width="53px"
                                            height="62px"
                                        />
                                    } @else {
                                        <img
                                            src="assets/img/check24_11.svg"
                                            alt="Check24: Tarifnote: 1,1 Sehr gut."
                                            width="53px"
                                            height="62px"
                                        />
                                    }
                                } @else {
                                    @if (hasTheftCoverage()) {
                                        <img
                                            src="assets/img/check24_11.svg"
                                            alt="Check24: Tarifnote: 1,1  Sehr gut."
                                            width="53px"
                                            height="62px"
                                        />
                                    } @else {
                                        <img
                                            src="assets/img/check24_10_gold.svg"
                                            alt="Check24: Tarifnote: 1,0 Exzellent."
                                            width="53px"
                                            height="62px"
                                        />
                                    }
                                }
                            </div>
                        </app-price-display-card>
                    </div>
                    <!-- #endregion -->
                </div>
            </div>
        </section>
        <!-- #endregion -->

        <!-- #region benefits -->
        <section class="bg:blue-gradient-rev c:white p-24:v md:p-32:v lg:p-48:v">
            <div class="content-container">
                <div class="grid-container -center-v">
                    <div class="g-12 md:g-6 lg:g-5 lg:g-offset-1">
                        <h2 class="c:white">Unsere Leistungen</h2>
                        <p class="l">
                            Die Leistungen von Handyversicherungen unterscheiden sich von Anbieter zu Anbieter. Mit der
                            astra Handyversicherung schützt du dein Smartphone weltweit, mit oder ganz ohne
                            Selbstbeteiligung im Schadensfall. Diese Leistungen sind in deinem Beitrag enthalten:
                        </p>
                    </div>
                    <div class="g-12 md:g-6">
                        <picture>
                            <source
                                srcset="/assets/img/astra-Versicherung-Handy-Leistung.webp"
                                type="image/webp"
                            />
                            <img
                                src="/assets/img/astra-Versicherung-Handy-Leistung.png"
                                alt="Die astra Handyversicherung bietet Schutz gegen Displayschäden, Flüssigkeitsschäden, Brand, Vandalismus, Sabotage und Diebstahl. Sofortschutz und schnelle Schadensabwicklung weltweit - mit oder ohne Selbstbeteiligung"
                                width="335px"
                                height="640px"
                                class="img:fluid img:center"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </section>
        <!-- #endregion -->

        <!-- #region benefits table-->
        <section class="p-24:t md:p-32:t lg:p-48:t p-16:b md:p-24:b">
            <div class="content-container">
                <h2 class="c:blue-700 hide md:block">Das leistet die astra {{ product().title }}</h2>
                <app-collapsible-table [tableData]="handyBenefits" />
                <p class="fs:s m-12:v md:m-16:v lg:m-24:v">
                    <a
                        [href]="'/assets/documents/' + product().presentation.docAVBUrl"
                        target="_blank"
                        rel="noreferrer noopener"
                        title="Allgemeine Versicherungsbedingungen (PDF)"
                        >Hier</a
                    >
                    kannst du unsere AVB mit den gesamten Leistungen downloaden.
                </p>
                <div class="grid-container -end m-16:t md:m-32:t">
                    <button
                        type="submit"
                        class="g-auto next"
                        [disabled]="form.invalid"
                    >
                        Diesen Tarif wählen
                    </button>
                </div>
            </div>
        </section>
        <!-- #endregion -->

        <!-- #region reasons for insurance -->
        <div class="bg:grey-5">
            <div class="content-container p-24:v md:p-32:v lg:p-48:v">
                <h2 class="c:blue-700">Gründe für eine Handyversicherung</h2>
                <p>
                    Wann ist eine Handyversicherung sinnvoll? Wir empfehlen dir eine Smartphoneversicherung, wenn du dir
                    bei einem Schaden oder Diebstahl die entstehenden Kosten entweder nicht leisten kannst oder nicht
                    leisten möchtest und das Risiko auf eine geringe monatliche Rate verlagern willst.
                </p>
                <ol class="numbered-list">
                    <li>Hochwertige, einfache und schnelle Reparatur</li>
                    <li>Schnelle und einfache Erreichbarkeit über Telefon und E-Mail</li>
                    <li>Transparente Versicherungsbedingungen</li>
                    <li>Schneller Support</li>
                    <li>Digitaler Abschluss und Online-Vertragsverwaltung</li>
                    <li>Keine Mindestlaufzeit, täglich kündbar</li>
                </ol>
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region insurance comparison -->
        <section class="p-24:t p-16:b md:p-32:t md:p-24:b lg:p-48:t">
            <div class="content-container">
                <h2 class="c:blue-700">Handyversicherung vs. Hausrat- / Haftpflichtversicherung</h2>
                <p class="l">
                    Dein Handy ist teilweise auch über andere Versicherungen geschützt. Die Haftpflichtversicherung
                    entschädigt nur, wenn du nicht dein eigenes Handy beschädigst. Die Hausratversicherung beschränkt
                    sich in den meisten Fällen auf die Schadensfälle in den eigenen vier Wänden.
                </p>
                <app-collapsible-table [tableData]="insuranceComparison" />
                <div class="grid-container -end m-16:t md:m-32:t">
                    <button
                        type="submit"
                        class="g-auto next"
                        [disabled]="form.invalid"
                    >
                        Diesen Tarif wählen
                    </button>
                </div>
            </div>
        </section>
        <!-- #endregion -->

        <!-- #region tips for smartphone -->
        <section class="bg:grey-5 p-24:t p-16:b md:p-32:t md:p-24:b lg:p-48:t">
            <div class="content-container">
                <h2 class="c:blue-700">Tipps für den sicheren Umgang mit deinem Smartphone</h2>
                <p class="l">
                    Mit diesen Tipps kannst du dein Handy vor den alltäglichen Gefahren schützen und die Langlebigkeit
                    steigern. Falls es doch mal zum Schaden kommt, ist die astra Handyversicherung für dich da!
                </p>
                <div class="grid-container">
                    <div class="g-12 md:g-6">
                        <div class="tip-smartphone">
                            <h4
                                class="tip-header"
                                data-number="1"
                            >
                                Handy schützen
                            </h4>
                            <ul class="check-blue">
                                <li>Handyhülle nutzen</li>
                                <li>Handyhalterung für einen besseren Halt</li>
                                <li>Ortungsfunktion aktivieren*</li>
                            </ul>
                        </div>
                    </div>
                    <div class="g-12 md:g-6">
                        <div class="tip-smartphone">
                            <h4
                                class="tip-header"
                                data-number="2"
                            >
                                Schäden vermeiden
                            </h4>
                            <ul class="check-blue">
                                <li>Handy von Wasserquellen fernhalten</li>
                                <li>Handy nicht in der hinteren Hosentasche transportieren</li>
                                <li>Handy nicht auf Kanten legen</li>
                            </ul>
                        </div>
                    </div>
                    <div class="g-12 md:g-6">
                        <div class="tip-smartphone">
                            <h4
                                class="tip-header"
                                data-number="3"
                            >
                                Akku schonen
                            </h4>
                            <ul class="check-blue">
                                <li>Akku zwischen 20&nbsp;% und 80&nbsp;% laden</li>
                                <li>Zu heiße und kalte Temperaturen vermeiden</li>
                                <li>Qualitative Ladegeräte nutzen</li>
                            </ul>
                        </div>
                    </div>
                    <div class="g-12 md:g-6">
                        <div class="tip-smartphone">
                            <h4
                                class="tip-header"
                                data-number="4"
                            >
                                Wasserschaden
                            </h4>
                            <ul class="check-blue">
                                <li>Handy sofort aus dem Wasser nehmen und ausschalten</li>
                                <li>Handy mit Tuch trocknen</li>
                                <li>Handy für 24&nbsp;Stunden in Reis legen</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <p>
                    *) Der Versicherungsschutz besteht bei Diebstahl nur, wenn die Geräteortungsfunktion unverzüglich
                    nach Abschluss des Versicherungsvertrages aktiviert worden ist (4.5 in den AVB).
                </p>
                <div class="grid-container -end m-16:t md:m-32:t">
                    <button
                        type="submit"
                        class="g-auto next"
                        [disabled]="form.invalid"
                    >
                        Diesen Tarif wählen
                    </button>
                </div>
            </div>
        </section>
        <!-- #endregion -->

        <!-- #region faq -->
        <section class="p-24:v md:p-32:v lg:p-48:t lg:p-96:b">
            <div class="content-container">
                <h2 class="c:blue-700">FAQ</h2>
                <p class="l m-24:b md:m-32:b lg:m-48:b">
                    Hier findest du Antworten auf die häufigsten Fragen zu allen Themen rund um unsere
                    Versicherungsangebote.
                </p>
                <app-faq-handy [productPresentation]="product().presentation" />

                <div class="grid-container -end m-16:t md:m-32:t">
                    <button
                        type="submit"
                        class="g-auto next"
                        [disabled]="form.invalid"
                    >
                        Diesen Tarif wählen
                    </button>
                </div>
            </div>
        </section>
        <!-- #endregion -->
    </form>
}
